import { createSlice } from "@reduxjs/toolkit"

type GlobalNavState = {
    isWorkspaceSwitcherOpen: boolean
    isAccountPopoutOpen: boolean
}

const initialState: GlobalNavState = {
    isWorkspaceSwitcherOpen: false,
    isAccountPopoutOpen: false,
}

export const globalNavSliceName = "global-nav" as const

export const {
    actions: {
        openWorkspaceSwitcher,
        closeWorkspaceSwitcher,
        openAccountPopout,
        closeAccountPopout,
    },
    reducer: GlobalNavReducer,
} = createSlice({
    name: globalNavSliceName,
    initialState,
    reducers: {
        openWorkspaceSwitcher: (state) => {
            state.isWorkspaceSwitcherOpen = true
        },
        closeWorkspaceSwitcher: (state) => {
            state.isWorkspaceSwitcherOpen = false
        },
        openAccountPopout: (state) => {
            state.isAccountPopoutOpen = true
        },
        closeAccountPopout: (state) => {
            state.isAccountPopoutOpen = false
        },
    },
})
